
define('ldsh!modules/client/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Client</h1>\n<a class="btn btn-default" href="#/client/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   First Name\n  </th>\n  \n  <th>\n   Last Name\n  </th>\n  \n  <th>\n   Organization\n  </th>\n  \n  <th>\n   Email\n  </th>\n  \n  <th>\n   Vat Name\n  </th>\n  \n  <th>\n   Vat Number\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Client-body">\n\t</tbody>\n</table>';

}
return __p
};});

